import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { API } from "../utils/api";

export default function Acceso() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken, setUser } = useAuth();
  const [error, setError] = useState(null);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const t = searchParams.get("t");
    const next = searchParams.get("next") || "/dashboard";
    const safeNext = next.startsWith("/") && !next.startsWith("//") ? next : "/dashboard";

    if (!t) {
      setError("Este enlace no es válido.");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/magic`, { token: t });
        const { token: newToken, user: userData } = res.data;
        localStorage.setItem("plazafy_token", newToken);
        localStorage.setItem("plazafy_user", JSON.stringify(userData));
        axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
        setToken(newToken);
        setUser(userData);
        navigate(safeNext, { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Este enlace ha caducado. Pide otro por WhatsApp.");
      }
    })();
  }, [searchParams, navigate, setToken, setUser]);

  return (
    <div className="min-h-screen bg-[#0f0c17] flex items-center justify-center px-4">
      {error ? (
        <div className="text-center max-w-sm" data-testid="acceso-error">
          <div className="w-14 h-14 rounded-2xl bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-5">
            <AlertCircle className="w-7 h-7 text-red-400" />
          </div>
          <p className="text-white font-semibold text-lg mb-2">No hemos podido iniciar tu sesión</p>
          <p className="text-gray-400 text-sm mb-6">{error}</p>
          <Link
            to="/login"
            data-testid="acceso-login-btn"
            className="inline-block px-6 py-3 rounded-xl bg-violet-600 hover:bg-violet-500 text-white font-medium text-sm transition-all"
          >
            Iniciar sesión
          </Link>
        </div>
      ) : (
        <div className="text-center" data-testid="acceso-loading">
          <Loader2 className="w-8 h-8 text-violet-400 animate-spin mx-auto mb-4" />
          <p className="text-gray-300">Iniciando tu sesión…</p>
          <p className="text-gray-500 text-sm mt-1">Un momento, por favor</p>
        </div>
      )}
    </div>
  );
}
